<script>
	import { createEventDispatcher } from 'svelte';
	import { person, logOut, helpCircleOutline, apps, search, settings as settingsIcon, pin, filing, stats, warning, brush } from 'ionicons/icons/index.mjs';
	import { getLocalServer } from '../shared/utils/Data.svelte';
	import Layers from '../shared/sidebar/Layers.svelte';
	import Search from '../shared/sidebar/Search.svelte';
	import Location from '../shared/sidebar/Location.svelte';
	import Log from '../shared/sidebar/Log.svelte';
	import Project from '../shared/sidebar/Project.svelte';
	import Draw from '../shared/sidebar/Draw.svelte';

	export let vitals;
	export let config;
	export let isPublic;
	export let links;
	export let projects;
	export let groups;
	export let session;
	export let keys;
	export let map;
	export let mapLoaded;
	export let workspace;
	export let layers;
	export let interactiveLayers;
	export let tab = "projects";
	export let location;
	export let history;
	export let messages;
	export let mapId;
	export let settings;
	export let tooltips;
	export let isDrawing;
	export let isMeasuring;
	export let selectedLayer;
	export let selectedFeature;
	
	const dispatch = createEventDispatcher();
	function sendMessage(message) {
		dispatch('message', message);
    }
</script>

<div id="tree" class="panel">
	<div class="panel-header p-2">
		<div class="btn-group btn-group-block">
			<button class="btn btn-sm {tooltips ? "tooltip tooltip-bottom" : ""} {tab == "layers" ? "active" : ""}" data-tooltip="Layers" on:click|stopPropagation={(e) => {
                e.currentTarget.blur();
				sendMessage({
					type: "tab",
					data: "layers"
				})
			}}><i class="svg">{@html apps.ios}</i></button>
			<button class="btn btn-sm {tooltips ? "tooltip tooltip-bottom" : ""} {tab == "search" ? "active" : ""}" data-tooltip="Search"  on:click|stopPropagation={(e) => {
                e.currentTarget.blur();
				sendMessage({
					type: "tab",
					data: "search"
				})
			}}><i class="svg">{@html search.md}</i></button>
			<button class="btn btn-sm {tooltips ? "tooltip tooltip-bottom" : ""} {tab == "location" ? "active" : ""}" data-tooltip="Location"  on:click|stopPropagation={(e) => {
                e.currentTarget.blur();
				sendMessage({
					type: "tab",
					data: "location"
				})
			}}><i class="svg">{@html pin.md}</i></button>
			{#if config.role >= 2}
			<button class="btn btn-sm {tooltips ? "tooltip tooltip-bottom" : ""} {tab == "log" ? "active" : ""}" data-tooltip="Report Log"  on:click|stopPropagation={(e) => {
                e.currentTarget.blur();
				sendMessage({
					type: "tab",
					data: "log"
				})
			}}><i class="svg">{@html filing.ios}</i></button>
			{/if}
			<button class="btn btn-sm {tooltips ? "tooltip tooltip-bottom" : ""} {tab == "project" ? "active" : ""}" data-tooltip="Project"  on:click|stopPropagation={(e) => {
                e.currentTarget.blur();
				sendMessage({
					type: "tab",
					data: "project"
				})
			}}><i class="svg">{@html stats.md}</i></button>
			<button class="btn btn-sm {tooltips ? "tooltip tooltip-bottom" : ""} {tab == "draw" ? "active" : ""}" data-tooltip="Draw"  on:click|stopPropagation={(e) => {
                e.currentTarget.blur();
				sendMessage({
					type: "tab",
					data: "draw"
				})
			}}><i class="svg">{@html brush.md}</i></button>
		</div> 
	</div>
	<div class="panel-body">
		{#if tab == "layers"}
			<Layers links={links} layers={layers} config={config} mapLoaded={mapLoaded} map={map} groups={groups} keys={keys} query={session.query} tooltips={tooltips} on:message />
		{:else if tab == "search"}
			<Search interactiveLayers={interactiveLayers} map={map} tooltips={tooltips} session={session} on:message />
		{:else if tab == "location"}
			<Location settings={settings} location={location} tooltips={tooltips} map={map} on:message />
		{:else if tab == "log"}
			<Log layers={layers} settings={settings} session={session} map={map} history={history} messages={messages} tooltips={tooltips} on:message />
		{:else if tab == "project"}
			<Project settings={settings} isPublic={isPublic} mapId={mapId} config={config} keys={keys} tooltips={tooltips} on:message />
		{:else if tab == "draw"}
			<Draw isDrawing={isDrawing} location={location} isMeasuring={isMeasuring} selectedLayer={selectedLayer} selectedFeature={selectedFeature} settings={settings} isPublic={isPublic} mapId={mapId} config={config} keys={keys} tooltips={tooltips} on:message />
		{/if}
	</div>
	<div class="panel-footer">
		<div class="tile tile-centered">
			<div class="tile-content">
				<div class="btn-group slant slant-right-reverse">
					{#if isPublic}
						<a class="btn btn-link {tooltips ? "tooltip tooltip-right" : ""}" href={"/?p=" + config.project + "&public"} data-tooltip="Dashboard"><i class="svg svg-light">{@html person.md}</i></a>
					{:else}
						<a class="btn btn-link {tooltips ? "tooltip tooltip-right" : ""}" href="/" data-tooltip="Dashboard"><i class="svg svg-light">{@html person.md}</i></a>
					{/if}
					<button class="btn btn-link {tooltips ? "tooltip tooltip-right" : ""}" data-tooltip="Settings" on:click={(e) => {
					e.currentTarget.blur();
					sendMessage({
						type: "modal",
						data: {
								view: "settings"
						}
					})
					}}><i class="svg svg-light">{@html settingsIcon.md}</i></button>
					{#if window.platform == "Android" && window.apiVersion >= 5}
						<button class="btn btn-link {tooltips ? "tooltip tooltip-right" : ""}" data-tooltip="Debug" on:click={async (e) => {
							e.currentTarget.blur();
							sendMessage({
								type: "modal",
								data: {
										view: "errors"
								}
							})
						}}><i class="svg svg-light">{@html warning.md}</i></button>
					{/if}			
					<button class="btn btn-link {tooltips ? "tooltip tooltip-right" : ""}" data-tooltip="Help" on:click={async (e) => {
						e.currentTarget.blur();
						sendMessage({
							type: "modal",
							data: {
									view: "info"
							}
						})
					}}><i class="svg svg-light">{@html helpCircleOutline.md}</i></button>
					<button class="btn btn-link {tooltips ? "tooltip tooltip-right" : ""}" data-tooltip="Sign Out" on:click={(e) => {
					e.currentTarget.blur();
					sendMessage({
						type: "session",
						data: {
							workspaces: ""
						}
					})
					}}><i class="svg svg-light">{@html logOut.md}</i></button>
				</div>
			</div>
			<div class="tile-action version">
					{ vitals.version }
			</div>
		</div>
	</div>
</div>

<style>
	.version {
		font-size: 80%;
		margin-top: 15px;
		margin-right: 5px;
	}
    #tree {
        position: fixed;
        overflow-y: auto;
        width: 300px;
        height: 100%;
	}
	.panel {
        border: 0;
	}
	.panel .panel-body {
		padding: 0;
    }
	.panel .panel-header {
		padding: 0;
		background: #efefef;
	}
	.panel .panel-footer {
		padding: 0;
		background: #efefef;
	}
	.svg {
		fill: #00ab5f;
	}
	.active .svg {
		fill: white;
	}
	.slant {
		color: white;
		background-color: #00ab5f;
		transform-origin: bottom left;
		position: relative;
		z-index: 1;
	}
	.slant-right-reverse:before {
		content: "";
		position: absolute;
		z-index: -1;
		top: 0;
		bottom: 0;
		right: 0;
		width: 20px;
		margin-right: -10px;
		background-color: #00ab5f;
		border-right: 2px solid #a9d9bb;
		-ms-transform: skew(30deg, 0deg);
		-webkit-transform: skew(30deg, 0deg);
		transform: skew(30deg, 0deg);
	}
	.slant .btn.btn-link {
		color: white;
	}
</style>
